module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/price-config-active.dd2cecd5.svg";